import First from "../../../../../assets/images/project/rumah/AWILIGAR_HOUSE/awiligar-house.jpg";

export default [
  {
    title: "Awiligar House",
    description: "Rumah Industrial Modern Minimalis",
    urls: First,
  },
];
